var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "file_copy_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#file_copy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.244 15.583H6.757c-.366 0-.68-.132-.944-.396a1.289 1.289 0 01-.396-.944V2.756c0-.365.132-.68.396-.944.264-.263.578-.395.944-.395h5.89a1.316 1.316 0 01.958.397l2.581 2.58a1.317 1.317 0 01.398.958v8.891c0 .366-.132.68-.396.944a1.289 1.289 0 01-.944.396zm.256-10h-2.198a.855.855 0 01-.629-.256.854.854 0 01-.256-.628v-2.2h-5.66a.245.245 0 00-.177.081.245.245 0 00-.08.176v11.487c0 .065.027.123.08.177.054.053.113.08.177.08h8.487a.245.245 0 00.176-.08.245.245 0 00.08-.177v-8.66zm-11.743 13c-.366 0-.68-.132-.944-.396a1.289 1.289 0 01-.396-.944V6.959a.526.526 0 01.537-.541c.153 0 .282.051.388.155a.519.519 0 01.158.386v10.286c0 .064.027.122.08.176.054.053.113.08.177.08h8.285a.527.527 0 01.542.537.532.532 0 01-.156.388.519.519 0 01-.386.158H3.757z",
    fill: "#7A8D8F"
  }))));
}
export default SvgFileCopy;